import { useSelector } from "react-redux";
import { selectUser, selectIsLoggedIn } from "./userSlice";
import { LocalUser } from "../utils/interface/localUser";
import { RootState } from "./store";


export function useUser(): LocalUser | null {
  return useSelector((state: RootState) => selectUser(state));
}

export function useIsLoggedIn(): boolean {
  return useSelector((state: RootState) => selectIsLoggedIn(state));
}
